const TRT_NUMBER_PATTERN = /^\d{7}$/;

export function isValidTRTNumber(value: string): boolean {
  return TRT_NUMBER_PATTERN.test(value);
}

export function getPhotoFileName(photoUrl: string | undefined): string | null {
  if (!photoUrl) return null;
  const fileName = photoUrl.split("?")[0].split("/").pop();
  return fileName ? decodeURIComponent(fileName) : null;
}

const FILE_NAME_TRT_PATTERN = /_(\d{7})\.[a-zA-Z0-9]+$/;

export function isPhotoTakenForTRTNumber(photoFileName: string | null, TRTNumber: string): boolean {
  if (!photoFileName || !TRTNumber) return true;
  const TRTNumberInFileName = photoFileName.match(FILE_NAME_TRT_PATTERN)?.[1];
  if (!TRTNumberInFileName) return true;
  return TRTNumberInFileName === TRTNumber;
}
